import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { SharedModule } from '@shared/shared.module';
import { DprDetailsRoutingModule } from './dpr-details-routing.module';
import { containerComponents } from './containers';
import { components } from './components';
import { services } from './services';
import { pipes } from './pipes';
import {
  DprLocalPersistenceService,
  DprRemotePersistenceService,
} from '@dpr/services/persistence';
import { DprService } from '@dpr/services';
import { DprOfflineService } from '@dpr/services/sync';

@NgModule({
  declarations: [containerComponents, components, pipes],
  imports: [
    CommonModule,

    // internals
    SharedModule,
    DprDetailsRoutingModule,
  ],
  providers: [
    services,
    pipes,
    DatePipe,
    DprService,
    DprRemotePersistenceService,
    DprLocalPersistenceService,
    DprOfflineService,
  ],
})
export class DprDetailsModule {}
